
import Vue, { PropOptions } from 'vue';
import _ from 'lodash';
import { numFormat } from '@/helpers/numFormat';
import { SalesCollection } from '@/models/page-models/page-items/SalesCollection';

export default Vue.extend({
  props: {
    input: { type: Object, default: () => {} }  as PropOptions<SalesCollection>,
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} },
    rowDisabled: { type: Boolean, default: false }
  },
  data () {
    return { salesGroupExpanded: '', salesmanExpanded: '' };
  },
  computed: {
    tableHeaders: function(): { text: string, value: string, align?: string }[] {
      const tableHeaders: { text: string, value: string, align?: string }[] = [
        { text: 'Group', value: 'salesGroup', align: 'center' },
        { text: 'Salesman', value: 'salesman', align: 'center' },
        { text: 'Customer', value: 'customer', align: 'center' },
        { text: 'Invoice', value: 'totalInvoiceSum', align: 'center' },
        { text: 'Receipt', value: 'totalApproved', align: 'center' },
        { text: 'Balance', value: 'balanceAmount', align: 'center' },
        { text: 'Late', value: 'lateAmount', align: 'center' },
        { text: '', value: 'data-expand' }
      ];
      return tableHeaders;
    },
    salesCollectionData: function(): any {
      return this.getVariable(this.input.salesCollectionVariable);
    },
    groupedCollectionData: function(): any[] {
      const collectionDataGroupedBySalesGroup = _.map(this.salesCollectionData, ((salesGroupCollectionData: any, salesGroup: string ) => {
        const collectionDataGroupedBySalesman = _.map(salesGroupCollectionData, ((salesmanCollectionData: any, salesman: string) => {
          const collectionDataGroupedByCustomer = _.map(salesmanCollectionData, ((customerCollectionDataArray: any[], customer: string) => {
            const customerCollectionData = customerCollectionDataArray[0];
            return {
              salesGroup,
              salesman,
              customer,
              ...customerCollectionData
            };
          }));
          const totalInvoiceSum = collectionDataGroupedByCustomer.reduce((totalInvoiceSum, customerData) => totalInvoiceSum + customerData.totalInvoiceSum, 0);
          const totalApproved = collectionDataGroupedByCustomer.reduce((totalApproved, customerData) => totalApproved + customerData.totalApproved, 0);
          const balanceAmount = collectionDataGroupedByCustomer.reduce((balanceAmount, customerData) => balanceAmount + customerData.balanceAmount, 0);
          const lateAmount = collectionDataGroupedByCustomer.reduce((lateAmount, customerData) => lateAmount + customerData.lateAmount, 0);
          return {
            salesGroup,
            salesman,
            customer: 'All',
            totalInvoiceSum,
            totalApproved,
            balanceAmount,
            lateAmount,
            collectionDataGroupedByCustomer: this.filterCollectionData(collectionDataGroupedByCustomer),
            expandable: 'salesman'
          };
        }));

        const totalInvoiceSum = collectionDataGroupedBySalesman.reduce((totalInvoiceSum, salesmanData) => totalInvoiceSum + salesmanData.totalInvoiceSum, 0);
        const totalApproved = collectionDataGroupedBySalesman.reduce((totalApproved, salesmanData) => totalApproved + salesmanData.totalApproved, 0);
        const balanceAmount = collectionDataGroupedBySalesman.reduce((balanceAmount, salesmanData) => balanceAmount + salesmanData.balanceAmount, 0);
        const lateAmount = collectionDataGroupedBySalesman.reduce((lateAmount, salesmanData) => lateAmount + salesmanData.lateAmount, 0);
        return {
          salesGroup,
          salesman: 'All',
          customer: 'All',
          totalInvoiceSum,
          totalApproved,
          balanceAmount,
          lateAmount,
          collectionDataGroupedBySalesman: this.filterCollectionData(collectionDataGroupedBySalesman),
          expandable: 'salesGroup'
        };
      }));
      const totalInvoiceSum = collectionDataGroupedBySalesGroup.reduce((totalInvoiceSum, salesGroupData) => totalInvoiceSum + salesGroupData.totalInvoiceSum, 0);
      const totalApproved = collectionDataGroupedBySalesGroup.reduce((totalApproved, salesGroupData) => totalApproved + salesGroupData.totalApproved, 0);
      const balanceAmount = collectionDataGroupedBySalesGroup.reduce((balanceAmount, salesGroupData) => balanceAmount + salesGroupData.balanceAmount, 0);
      const lateAmount = collectionDataGroupedBySalesGroup.reduce((lateAmount, salesGroupData) => lateAmount + salesGroupData.lateAmount, 0);
      const totalCollectionData: any[] = [
        {
          salesGroup: 'All',
          salesman: 'All',
          customer: 'All',
          totalInvoiceSum,
          totalApproved,
          balanceAmount,
          lateAmount
        }
      ];
      _.sortBy(collectionDataGroupedBySalesGroup, 'salesGroup').forEach((salesGroupCollectionData: any) => {
        const { collectionDataGroupedBySalesman, ...salesGroupCollectionSummary } = salesGroupCollectionData;
        totalCollectionData.push(salesGroupCollectionSummary);
        if(salesGroupCollectionSummary.salesGroup == this.salesGroupExpanded) {
          collectionDataGroupedBySalesman.forEach((salesmanCollectionData: any) => {
            const { collectionDataGroupedByCustomer, ...salesmanCollectionSummary } = salesmanCollectionData;
            totalCollectionData.push(salesmanCollectionSummary);
            if(salesmanCollectionSummary.salesman == this.salesmanExpanded) {
              totalCollectionData.push(...collectionDataGroupedByCustomer);
            }
          });
        }
        
      });
      return totalCollectionData;
    }
  },
  mounted() {
  },
  methods: {
    expand(expandableType: 'salesGroup' | 'salesman', expandValue: string) {
      if(expandableType == 'salesGroup') {
        this.salesGroupExpanded = expandValue;
      } else {
        this.salesmanExpanded = expandValue;
      }
    },
    collapse(expandableType: 'salesGroup' | 'salesman') {
      if(expandableType == 'salesGroup') {
        this.salesGroupExpanded = '';
      }
      if(['salesGroup', 'salesman'].includes(expandableType)) {
        this.salesmanExpanded = '';
      }
    },
    formatNumber(numValue: number): string | number {
      return numFormat(numValue);
    },
    filterCollectionData(collectionDataArray: any[]): any[] {
      return collectionDataArray.filter((collectionData: any) => {
        // return true;
        if(collectionData.balanceAmount >= 100 || collectionData.balanceAmount <= -100) return true;
        if(collectionData.totalInvoiceSum >= 100 || collectionData.totalInvoiceSum <= -100) return true;
        if(collectionData.totalApproved >= 100 || collectionData.totalApproved <= -100) return true;
        return false;
      })
    }
  }
});
